import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { keycloak } = useKeycloak();
  const { t } = useTranslation("pages");
  return (
    <div className="page">
      <h1>{t("homepage.title")}</h1>
      {!keycloak.authenticated && (
        <button
          type="button"
          className="text-blue-800"
          onClick={() => keycloak.login()}>
          Login
        </button>
      )}
    </div>
  );
};

export default Home;
